import { useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { useSelector } from 'react-redux';
import { AppCard, AppRemixIcon } from '@/layout/AppComponents';
import { UnmountClosed } from 'react-collapse/lib/UnmountClosed';
import { useParams } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';
import colors from '../../../../../../constants/colors';
import AppSpinner from '../../../../../components/AppSpinner';
import Translator from '../../../../../components/helpers/Translator';
import GGCLIconListBlock from '../CardElements/GGCLIconListBlock';
import GGCLStatesBlock from '../CardElements/GGCLStatesBlock';
import GGCLExpandedContainer from '../ExpandedTabs/GGCLExpandedContainer';
import GGCLApplicableDateBlock from '../CardElements/GGCLApplicableDateBlock';
import _ from 'lodash';

export default function GGCLObligationDefault(props) {
  const { obligationID } = props;
  const { moduleBridgeHex } = useParams();
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex].permissions,
  );
  const userBridgePermissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.userBridge?.permissions,
  );
  const poLevel1 = useSelector(
    (state) => state.currentPage?.obligationLevels?.level1,
  );
  const poLevel2 = useSelector(
    (state) => state.currentPage?.obligationLevels?.level2,
  );
  const poLevel3 = useSelector(
    (state) => state.currentPage?.obligationLevels?.level3,
  );
  const [isOpened, setIsOpened] = useState(false);
  if (!poLevel1) {
    return (
      <div className="card o-default">
        <div className="card-body" />
      </div>
    );
  }
  return (
    <Container
      $userBridgePermissions={userBridgePermissions}
      $permissions={permissions}
      $border={poLevel3?.[obligationID]?.border || 'white'}
    >
      <AppCard bodyClassName="o-default">
        <div className="poBlock-obligation-state">
          {_.map(poLevel3?.[obligationID]?.states?.states, (s) => (
            <OverlayTrigger
              key={s.name}
              placement="right"
              overlay={<Tooltip>{`${s.name} - ${s.percent}%`}</Tooltip>}
            >
              <div
                className="progress-bar"
                style={{
                  height: `${s.percent}%`,
                  background: s.bgColor,
                }}
              />
            </OverlayTrigger>
          ))}
        </div>

        <div className="poBlock-obligation pt-0">
          {poLevel1?.[obligationID] ? (
            <h3>
              <span>{poLevel1[obligationID]?.obligation.category}</span> /{' '}
              <span>{poLevel1[obligationID]?.obligation.subcategory}</span>
              <div className="mt-1">
                •
                <span className="ml-2">
                  {poLevel1[obligationID]?.obligation.note}
                </span>
              </div>
            </h3>
          ) : (
            ''
          )}
          <Scrollbars style={{ height: '100px' }}>
            {poLevel1?.[obligationID]?.obligation?.obligationVersion
              ?.obligation ? (
              <>
                <GGCLApplicableDateBlock obligationID={obligationID} isH3 />

                {poLevel1[obligationID]?.obligation?.hasFormat ? (
                  <div
                    className="pr-2"
                    dangerouslySetInnerHTML={{
                      __html:
                        poLevel1[obligationID]?.obligation?.obligationVersion
                          ?.obligation,
                    }}
                  />
                ) : (
                  <div className="pr-2" style={{ whiteSpace: 'pre-line' }}>
                    {
                      poLevel1[obligationID]?.obligation?.obligationVersion
                        ?.obligation
                    }
                  </div>
                )}
              </>
            ) : (
              ''
            )}
          </Scrollbars>
        </div>
        {permissions?.ggcl?.nextDateEvidenceBlock && (
          <div className="poBlock-nextDate-evidence">
            <div>
              <h3 className="d-flex align-items-center justify-content-between">
                <span>
                  <Translator
                    file="module-legalCompliance"
                    name="module.lc.nextDate"
                  />
                </span>
                <div>{/* //BORRAR DIV */}</div>
              </h3>
              <Scrollbars
                // style={{   //WIP
                //   height: permissions?.gcl?.module?.plant?.evidences
                //     ? '50px'
                //     : '112px',
                // }}
                style={{
                  height: 1 === 1 ? '50px' : '112px',
                }}
              >
                {poLevel1?.[obligationID] ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        poLevel1[obligationID]?.obligation?.obligationVersion
                          ?.nextDate,
                    }}
                  />
                ) : (
                  '...'
                )}
              </Scrollbars>
            </div>
            {/* {permissions?.gcl?.module?.plant?.evidences && //WIP */}
            {1 === 1 &&
              (userBridgePermissions?.level !== 2 ||
                userBridgePermissions?.evidences?.read === true) && (
                <div>
                  <h3 className="d-flex align-items-center justify-content-between mb-0">
                    <span>
                      <Translator
                        file="module-legalCompliance"
                        name="evidences"
                      />
                    </span>
                    <div>
                      {[1, 2].includes(
                        poLevel2?.[obligationID]?.obligation?.evidenceType,
                      ) ? (
                        <AppRemixIcon
                          icon={
                            poLevel2?.[obligationID]?.obligation
                              ?.evidenceType === 1
                              ? 'eye'
                              : 'folder-open'
                          }
                          title={
                            poLevel2?.[obligationID]?.obligation
                              ?.evidenceType === 1
                              ? ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="visual"
                                  />,
                                )
                              : ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="documental"
                                  />,
                                )
                          }
                          color={colors.primary}
                          size={14}
                          className="pl-1"
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </h3>
                  <Scrollbars style={{ height: '50px' }}>
                    {poLevel1?.[obligationID] ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            poLevel1[obligationID]?.obligation
                              ?.obligationVersion?.evidence,
                        }}
                      />
                    ) : (
                      '...'
                    )}
                  </Scrollbars>
                </div>
              )}
          </div>
        )}
        {permissions?.ggcl?.stateInfoBlock && (
          <>
            {poLevel3 ? (
              <GGCLStatesBlock obligationID={obligationID} />
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                <AppSpinner>
                  <AppRemixIcon
                    icon="loader-4"
                    size={30}
                    color={colors.primaryLight}
                  />
                </AppSpinner>
              </div>
            )}
          </>
        )}

        {/* {1 === 2 &&
          (permissions?.gcl?.module?.plant?.probSevRisk?.probability ||
            permissions?.gcl?.module?.plant?.probSevRisk?.severity ||
            permissions?.gcl?.module?.plant?.probSevRisk?.risk) && (
            <>
              {poLevel3 ? (
                <div className="poBlock-probSevRisk">
                  <ProbSevRiskBlock plantObligation={plantObligationID} />
                </div>
              ) : (
                <div className="relative poBlock-init-end">
                  <AppSpinner>
                    <AppRemixIcon
                      icon="loader-4"
                      size={30}
                      color={colors.primaryLight}
                    />
                  </AppSpinner>
                </div>
              )}
            </>
          )} */}
        <div className="poBlock-icons">
          {poLevel2 ? (
            <div className="icon-grid">
              <GGCLIconListBlock obligationID={obligationID} />
            </div>
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              <AppSpinner>
                <AppRemixIcon
                  icon="loader-4"
                  size={30}
                  color={colors.primaryLight}
                />
              </AppSpinner>
            </div>
          )}
          <div
            className="hex-block"
            title={`CODE ${poLevel1?.[obligationID]?.obligation?.hex}`}
          >
            <small>CODE</small>
            <br />
            {poLevel1?.[obligationID]?.obligation?.hex}
          </div>
        </div>

        <div
          className="poBlock-init-end bg-primary pointer"
          onClick={() => setIsOpened(!isOpened)}
        >
          <AppRemixIcon icon={isOpened ? 'subtract' : 'add'} color="white" />
        </div>
        <div />
      </AppCard>
      <UnmountClosed isOpened={isOpened}>
        <GGCLExpandedContainer obligationID={obligationID} />
      </UnmountClosed>
    </Container>
  );
}

const Container = styled.div`
  border-radius: 3px;
  .o-default {
    padding: 2px;
    height: 160px;
    display: grid;
    grid-template-columns:
      12px
      1fr //Obligation
      ${(props) =>
        props.$permissions?.ggcl?.nextDateEvidenceBlock &&
        '190px'} //Periodicity/Evidence
      ${(props) =>
        props.$permissions?.ggcl?.stateInfoBlock && '220px'} //State Charts
      46px //IconList
      40px; //Expand
    overflow: hidden;
    border: 1px
      ${(props) =>
        props.border === 'white'
          ? `solid ${colors.primaryLight}`
          : ` solid ${props.border}`};

    .poBlock-obligation-state {
      background: ${(props) =>
        props.$border === 'white'
          ? `repeating-linear-gradient(-45deg,white,white 4px,${colors.grey300} 4px,${colors.grey300} 10px)`
          : props.border};
      height: 154px;
    }
    h3 {
      font-weight: normal;
      color: ${colors.primaryLight};
    }
    & > div:not(.poBlock-obligation-state) {
      border-right: 1px solid ${colors.grey300};
    }
    & > .poBlock-init-end {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 2px;
      font-size: 30px;
      padding: 0;
      height: 154px;
    }
    & > .poBlock-obligation {
      padding: 10px;
      overflow: hidden;
      border-radius: 2px;
      font-size: 13px;
      border-right: 1px solid $gray-300;
    }
    & > .poBlock-nextDate-evidence {
      padding: 10px;
      border-right: 1px solid $gray-300;
      font-size: 11px;
    }
    & > .oBlock-states {
      height: 100%;
      display: grid;
      grid-template-rows: 20px 1fr;

      .obBlock-state-list {
        height: 100%;
        padding-top: 6px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 24px 24px 24px 24px 24px 24px 24px 24px 24px 24px;
      }
    }
    & > .poBlock-icons {
      height: 90%;
      display: grid;
      grid-template-rows: 1fr 30px;
      .icon-grid {
        padding: 3px;
        display: grid;
        grid-template-columns: 20px 20px;
        grid-template-rows: 20px 20px 20px 20px 20px 20px;
        height: 70%;
        & > i {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .hex-block {
        font-size: 10px;
        text-transform: uppercase;
        text-align: center;
        font-weight: bold;
        color: ${colors.primaryLight};
        //margin-top: 16px;
      }
    }
    & > .poBlock-probSevRisk {
      max-height: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px;
      font-weight: bold;
      color: ${colors.primary};
      span {
        padding: 10px 0;
      }
    }
    & > .poBlock-impactProb {
      max-height: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px;
      font-weight: bold;
      color: ${colors.primary};
      justify-content: center;
      span {
        padding: 10px 0;
      }
    }
  }
  h3 {
    font-size: 13px;
    color: $primary;
    margin: 0 0 6px 0;
    font-weight: bold;
  }
  h4 {
    font-size: 10px;
    color: $primary;
    text-transform: uppercase;
  }
`;
// En o-default 19-01-2026
// grid-template-columns:
//       12px
//       /* ${(props) =>
//         props.permissions?.gcl?.module?.plant?.states && '40px'} //State */
//       1fr //Obligation
//       ${(props) =>
//         props.$permissions?.ggcl?.nextDateEvidenceBlock &&
//         '190px'} //Periodicity/Evidence
//       ${(props) =>
//         props.$permissions?.ggcl?.stateInfoBlock && '220px'} //State Charts
//       46px //IconList
//       40px; //Expand
